import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Layout } from "antd";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Home from "./pages/home/Home";
import Inquire from "./pages/inquire/Inquire";
import Portfolio from "./pages/portfolio/Portfolio";
import Pricing from "./pages/pricing/Pricing";
import NotFound from "./components/NotFound";
import BlogPost from "./pages/blogs/BlogPost";
import Blog from "./pages/blogs/Blog";
import { useData } from "./contexts/DataContext";
import ResizeListener from "./components/ResizeListener";
import { fetchGlobalData, fetchSubscribePage } from "./services/ApiService";

const { Content } = Layout;

const App: React.FC = () => {
  const { state, dispatch } = useData();

  useEffect(() => {
    if (!state.globalData) {
      fetchGlobalData(dispatch);
    }
    if (!state.subscribePage) {
      fetchSubscribePage(dispatch);
    }
  }, [dispatch, state.globalData, state.subscribePage]);
  return (
    <Router>
      <Layout>
        <Navbar />
        <Content
          style={{
            paddingTop: "20px",
          }}
        >
          <ResizeListener />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:blogPostPath" element={<BlogPost />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/inquire" element={<Inquire />} />
            <Route path="*" element={<NotFound />} /> {/* Not Found Route */}
          </Routes>
        </Content>
        <Footer />
      </Layout>
    </Router>
  );
};

export default App;
